import React from 'react';

export const contentLayouts = {
    default: 'content',
    fullWidth: 'content full-width'
}

export const ContentLayoutContext = React.createContext(null);